/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  getLeaseInterventionListLink,
  getLeaseInvoiceListLink,
  getLeaseLink,
  getLeaseManagementReportListLink,
  getLeaseRentalReportListLink
} from '../../lib/links/leaseLinks'
import { Button, ButtonVariant, Group } from '@mantine/core'
import { useLocation } from 'react-router'
import { matchPath, NavLink } from 'react-router-dom'
import RequirePerm from '../../../auth/components/RequirePerm'

export type LeaseTabsProps = {
  leaseId: number
}

function LeaseTabs (props: LeaseTabsProps) {
  const intl = useIntl()
  const { leaseId } = props
  const disabled = !(leaseId > 0)
  const location = useLocation()
  const activeVariant: ButtonVariant = 'outline'
  const inactiveVariant: ButtonVariant = 'white'
  return (
    <Group gap="xs">
      <Button
        disabled={disabled}
        component={NavLink}
        to={getLeaseLink(leaseId)}
        variant={matchPath(getLeaseLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
      >
        {intl.formatMessage({
          id: 'record',
          defaultMessage: 'Fiche'
        })}
      </Button>
      <RequirePerm
        permissions={['read:invoice']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getLeaseInvoiceListLink(leaseId)}
            variant={matchPath(getLeaseInvoiceListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'invoices',
              defaultMessage: 'Factures'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:intervention']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getLeaseInterventionListLink(leaseId)}
            variant={matchPath(getLeaseInterventionListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'interventions',
              defaultMessage: 'Interventions'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:management-report']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getLeaseManagementReportListLink(leaseId)}
            variant={matchPath(getLeaseManagementReportListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'management_reports',
              defaultMessage: 'Rapports de gérance'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:management-report']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getLeaseRentalReportListLink(leaseId)}
            variant={matchPath(getLeaseRentalReportListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'rental_reports',
              defaultMessage: 'Rapports de location'
            })}
          </Button>
        )}
      />
    </Group>
  )
}

export default LeaseTabs
